import moment from 'moment'
import React, { Component } from 'react'
import { Link } from 'react-router-dom'

export default class MobileHeader extends Component {
    render() {
        return (
            <div className='flex lg:hidden flex-row gap-x-8 justify-center bg-white drop-shadow-lg mt-2 p-4'>
                <Link to="/dashboard" className='flex flex-row gap-x-2'>
                    <span className='font-semibold text-sm text-[#130D0D]'>Dashboard</span>
                </Link>

                <Link to="/talents" className='flex flex-row gap-x-2'>
                    <span className='font-semibold text-sm text-[#130D0D]'>Talents</span>
                </Link>

                <Link to={`/projects/${moment().year()}`} className='flex flex-row gap-x-2'>
                    <span className='font-semibold text-sm text-[#130D0D]'>Projects</span>
                </Link>

                <Link to="/users" className='flex flex-row gap-x-2'>
                    <span className='font-semibold text-sm text-[#130D0D]'>Users</span>
                </Link>
            </div>)
    }
}
